import { useEffect } from "react";
import "particles.js"; // Global script шиг ачаалдаг

const MapWithParticles = () => {
  useEffect(() => {
    // particlesJS глобалд байгаа эсэхийг шалгаж биндэлнэ
    const pJS = window.particlesJS || window.pJSDom;

    if (!window.particlesJS) {
      // particles.js дотор particlesJS global function-ийг window руу гаргадаг
      window.particlesJS = window.pJSDom?.[0]?.pJS?.fn?.interact?.linkParticles
        ? window.particlesJS
        : window.pJSDom;
    }

    function initParticles(id) {
      window.particlesJS(id, {
        particles: {
          number: { value: 180, density: { enable: true, value_area: 800 } },
          color: { value: "#ffffff" },
          shape: { type: "circle" },
          opacity: { value: 0.7 },
          size: { value: 2, random: true },
          line_linked: {
            enable: true,
            distance: 100,
            color: "#fff",
            opacity: 0.4,
            width: 1,
          },
          move: { enable: true, speed: 3, out_mode: "out" },
        },
        interactivity: {
          detect_on: "canvas",
          events: {
            onhover: { enable: true, mode: "grab" },
            onclick: { enable: true, mode: "push" },
          },
          modes: {
            grab: { distance: 150, line_linked: { opacity: 1 } },
            push: { particles_nb: 4 },
          },
        },
        retina_detect: true,
      });
    }

    setTimeout(() => {
      initParticles("left-particles");
      initParticles("right-particles");
    }, 200); // DOM бүрэн болсон хойно ажиллуулна
  }, []);

  return (
    <div style={{ height: "100%", width: "100%", overflow: "hidden" }}>
      {/* Left particles */}
      <div
        id="left-particles"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "20%",
          height: "100%",
          pointerEvents: "none",
        }}
      ></div>

      {/* Right particles */}
      <div
        id="right-particles"
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          width: "20%",
          height: "100%",
          pointerEvents: "none",
        }}
      ></div>

      {/* Таны SVG газрын зураг → эндээ байршуулна */}
    </div>
  );
};

export default MapWithParticles;
